import React from "react";
import type { LabelProps } from "@fluentui/react-label";
import type { SpinButtonOnChangeData, SpinButtonProps } from "@fluentui/react-spinbutton";
import { Label } from "@fluentui/react-label";
import { SpinButton } from "@fluentui/react-spinbutton";

interface SpinButtonFilterProps {
  controlId: string;
  controlStyle: string;
  labelProps: LabelProps;
  labelText: string;
  labelStyle: string;
  value: number | null;
  setValue: (value: number | null) => void;
  spinButtonProps: SpinButtonProps;
  disabled: boolean;
}

const SpinButtonFilter = (props: SpinButtonFilterProps): React.JSX.Element => {
  const onChange = (_: any, data: SpinButtonOnChangeData) => {
    if (data.value || data.value === 0) {
      props.setValue(data.value);
    } else if (data.displayValue && parseInt(data.displayValue) >= 0) {
      props.setValue(parseInt(data.displayValue));
    } else {
      props.setValue(null);
    }
  };

  return (
    <>
      <div className={props.labelStyle}>
        <Label htmlFor={props.controlId} {...props.labelProps}>
          {props.labelText}
        </Label>
      </div>
      <div className={props.controlStyle}>
        <SpinButton
          min={0}
          id={props.controlId}
          value={props.value}
          onChange={onChange}
          {...props.spinButtonProps}
          disabled={props.disabled}
        />
      </div>
    </>
  );
};

export default SpinButtonFilter;
